export function tableV2CellTestId(tableTestId: string | undefined, rowId: number | string, columnName: string) {
  return `${tablePrefix(tableTestId)}cell-${rowId}-${columnName}`;
}

export function tableV2RowTestId(tableTestId: string | undefined, rowId: number | string) {
  return `${tablePrefix(tableTestId)}-row-${rowId}`;
}

export function tableV2HeaderTestId(tableTestId: string | undefined, columnName: string) {
  return `${tablePrefix(tableTestId)}header-${columnName}`;
}

function tablePrefix(tableTestId: string | undefined) {
  if (tableTestId) {
    return `${tableTestId}-`;
  } else {
    return '';
  }
}
